/*eslint react-hooks/exhaustive-deps: "off"*/
/*eslint no-unused-vars: "off"*/
import React, { useEffect, useState } from "react";
import MapBase from "./MapBase";
import { PALETTE_YlOrRd_9, TRANSPARENT_COLOR } from "../../utils/Palette";
import useMapProps from "./useMapProps";
import { MapPropsProvider } from "./MapPropsContext";
import { WELL_KNOWN_POSITION } from "../../Constants";
import WidgetContainer from "./widgets/WidgetContainer";
import {
  arrayToRgb,
  getApiUrl,
  getLastYear,
  makeTableSorterFn,
  numberWithCommas,
} from "../../utils";
import WidgetCodeForStats from "./widgets/WidgetCodeForStats";
import RMateChartFusionPopulation from "./r_mate_chart/RMateChartFusionPopulation";
import Seperator from "./widgets/Seperator";
import WidgetStatisticsTable from "./widgets/WidgetStatisticsTable";
import WidgetSelectYear from "./widgets/WidgetSelectYear";
import WidgetRisingTabs from "./widgets/WidgetRisingTabs";
import WidgetDistrictSelect from "./widgets/WidgetDistrictSelect";
import WidgetToolbar from "./widgets/WidgetToolbar";
import WidgetLegend from "./widgets/WidgetLegend";
import AlignRightText from "./widgets/AlignRightText";

function MapFusionPopulation() {
  const [fillColorLegend, setFillColorLegend] = useState([]);

  const mapProps = useMapProps({
    INITIAL_VIEW_STATE: {
      ...WELL_KNOWN_POSITION.세종특별자치시,
      zoom: 8,
    },
    INITIAL_GEOJSON_EXTRA_PARAMS: {
      year: getLastYear(),
      month: 12,
      currentDistrictCode: "",
    },
    INITIAL_GEOJSON_POLYGON_LAYER_PROPS: {
      getHoverHtml: (object, mapDistrictStats) => {
        const [metricObject] = mapDistrictStats;
        const {
          properties: { pk, name },
        } = object;
        const code = pk;
        const obj = metricObject[code];
        if (obj) {
          const { total, totalPopulation, density } = obj;
          return `<span class='fontStyle'>${name}</span><br/> 
                  무선국 수 : ${numberWithCommas(total)} 개<br/>
                  인구 수 : ${numberWithCommas(totalPopulation)} 명<br/>
                  무선국 밀도 : ${numberWithCommas(
                    density.toFixed(2)
                  )} (국수/인구 천 명)`;
        }
        return `<span class='fontStyle'>${name}</span><br/> 
                무선국 수 : 0 개<br/>
                인구 수 : 0 명<br/>
                무선국 밀도 : 0 (국수/인구 천 명)`;
      },
      getLevelFillColor: ({ properties: { pk } }, mapDistrictStats) => {
        const [metricObject, metricMax] = mapDistrictStats;
        const code = pk;
        const obj = metricObject[code];
        // 데이터가 없더라도 색을 입힙니다.
        if (obj) {
          const { total } = metricObject[code] || { total: 1 };
          if (total >= 1) {
            const index = Math.floor(
              (PALETTE_YlOrRd_9.length * (total - 1)) / metricMax
            );
            return PALETTE_YlOrRd_9[index];
          }
          return TRANSPARENT_COLOR;
        }
        return TRANSPARENT_COLOR;
      },
    },
    INITIAL_WIDGET_STATE: {
      service_code_stats_list: ["2G", "3G", "LTE", "5G"],
      cls_code_stats_list: [
        "32",
        "94",
        "44",
        "85",
        "49",
        "92",
        "42",
        "41",
        "21",
        "CMFL",
        "OTHER",
      ],
      //isClsSearch: false, // 서비스검색을 기본 조건으로 세팅합니다.
      isClsSearch: true, // 무선국종을 기본 조건으로 세팅합니다.
    },
  });

  const {
    widgetState,
    dataResponseList,
    setMapDistrictStats,
    isChangedMapDistrictStats,
    clickedPolygonGeojsonObjects,
    geojsonExtraParams,
    setCurrentDistrictCode,
    currentDistrictCode,
    setGeojsonExtraParams,
    setChartAjaxParams,
    setTableAjaxParams,
    mapDistrictStats,
  } = mapProps;

  const [statsJsonSearchCodeList, setStatsJsonSearchCodeList] = useState([
    "2G",
    "3G",
    "LTE",
    "5G",
  ]);

  useEffect(() => {
    const { cls_code_stats_list, service_code_stats_list, isClsSearch } =
      widgetState;

    // ajax 변수 세팅 2. 구분코드와 파라미터 리스트
    if (isClsSearch) {
      // 무선국종 검색조건일 경우
      setStatsJsonSearchCodeList(cls_code_stats_list);
    } else {
      // 서비스 검색조건일 경우
      setStatsJsonSearchCodeList(service_code_stats_list);
    }

    const { year } = geojsonExtraParams;
    setChartAjaxParams((prevState) => ({
      ...prevState,
      searchYear: year,
      prm_check: service_code_stats_list,
      prm_check2: cls_code_stats_list,
      gubun_code: isClsSearch ? "cls" : "service",
    }));
  }, [widgetState, geojsonExtraParams]);

  useEffect(() => {
    const metricObject = {};

    // FIXME: 현행 사이트 및 데이터에서 제주도 무선국이 도출되지 않습니다. 확인이 필요합니다.
    if (dataResponseList.length > 0 && statsJsonSearchCodeList.length > 0) {
      const firstDataLayer = dataResponseList[0];
      for (let [code, stats] of Object.entries(firstDataLayer)) {
        // total: 해당 도/시의 무선국 수
        // total_population : 해당 도/시의 인구수
        // density: 해당 도/시의 무선국 수 / 인구수(1000단위)

        let stationTotal = 0;
        for (let division_code of statsJsonSearchCodeList) {
          const divisionValue = stats[division_code];
          if (divisionValue) {
            stationTotal += divisionValue;
          }
        }
        const total = stationTotal;
        const totalPopulation = stats["total_population"];
        // Hover 값 : 무선국 수, 인구수, 무선국 밀도
        if (totalPopulation !== undefined && total !== 0) {
          metricObject[code] = {
            total,
            totalPopulation,
            density: total / Math.floor(totalPopulation / 1000),
          };
        } else {
          metricObject[code] = { total, totalPopulation: 0, density: 0 };
        }
      }
    }
    const metricMax = Math.max(
      ...Object.values(metricObject).map((obj) => obj.total)
    );

    const newMapDistrictStats = [metricObject, metricMax];
    if (isChangedMapDistrictStats(newMapDistrictStats)) {
      setMapDistrictStats(newMapDistrictStats);

      // ajax 통신을 위한 변수 세팅 시작
      const chkRadSvcString = JSON.stringify({
        data: statsJsonSearchCodeList.map((CHK_VALUE) => ({ CHK_VALUE })),
      });
      const sidoCode = (currentDistrictCode || "").substr(0, 2);

      setChartAjaxParams((prevState) => ({
        ...prevState,
        sidoCode,
        chkRadSvcString,
      }));
      // 끝 ////////
    }
  }, [dataResponseList, statsJsonSearchCodeList, currentDistrictCode]);

  useEffect(() => {
    const { year } = geojsonExtraParams;

    setTableAjaxParams({
      sidoCode: (currentDistrictCode || "").substr(0, 2),
      searchEnd: year,
    });
  }, [widgetState, geojsonExtraParams]);

  /* ////1005_시군구 클릭 임시막기
  useEffect(() => {
    if (clickedPolygonGeojsonObjects.length > 0) {
      const firstLayer = clickedPolygonGeojsonObjects[0];
      const {properties: {name, pk}} = firstLayer;
      if ((pk || '').length <= 2) {
        setCurrentDistrictCode(pk);
      }
    }
  }, [clickedPolygonGeojsonObjects]);
*/

  useEffect(() => {
    setGeojsonExtraParams((prev) => ({
      ...prev,
      currentDistrictCode,
    }));
  }, [currentDistrictCode]);

  useEffect(() => {
    const [metricObject, metricMax] = mapDistrictStats;
    if (window.isFinite(metricMax) && metricMax > 0) {
      setFillColorLegend(
        [...Array(9).keys()]
          .map((colorIndex) => {
            const boundary = (metricMax / 9) * (colorIndex + 1);
            const index = Math.floor(
              (PALETTE_YlOrRd_9.length * (boundary - 1)) / metricMax
            );
            const colorRgb = arrayToRgb(PALETTE_YlOrRd_9[index]);
            return [colorRgb, boundary];
          })
          .reverse()
      );
    } else {
      // 데이터가 없을때
      setFillColorLegend(
        [...Array(1).keys()]
          .map((colorIndex) => {
            const boundary = 0;
            const colorRgb = "#ffffd9";
            return [colorRgb, boundary];
          })
          .reverse()
      );
    }
  }, [mapDistrictStats]);

  const { isClsSearch } = widgetState;

  return (
    <>
      <MapPropsProvider value={mapProps}>
        <MapBase
          isHideWidgetToggleClustering={true}
          isHideWidgetMapLayerTypes={true}
        >
          <WidgetContainer>
            <div>
              <WidgetDistrictSelect
                isShowDistrictLayerFromGeoserver={true}
                onlyLv1={true}
              />
              <WidgetSelectYear />
              <Seperator />
              <WidgetCodeForStats />
            </div>
          </WidgetContainer>
          <WidgetRisingTabs
            titleOnInit={[
              "각 구역에 대한 무선국 밀도(국수/인구 천 명) 요약정보",
              "각 구역에 대한 무선국 밀도(국수/인구 천 명) 상세정보",
            ]}
          >
            {!isClsSearch ? (
              <WidgetStatisticsTable
                fetchUrl={getApiUrl({ type: "type1" })}
                getTitle={(layer) =>
                  `각 구역에 대한 무선국 밀도(국수/인구 천 명) 요약정보`
                }
                type={"type1"}
                isSummaryInfo={true}
                columns={[
                  {
                    title: "순번",
                    dataIndex: "index",
                    key: "index",
                    width: 75,
                    fixed: "left",
                    // sorter: makeTableSorterFn("index"),
                  },
                  // { title: "지역", dataIndex: "gubun_nm", key: "gubun_nm", sorter: makeTableSorterFn("gubun_nm") },
                  {
                    title: "합계",
                    dataIndex: "tot_cnt",
                    key: "tot_cnt",
                    // sorter: makeTableSorterFn("tot_cnt"),
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "2G",
                    dataIndex: "2g_cnt",
                    key: "2g_cnt",
                    // sorter: makeTableSorterFn("2g_cnt"),
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "3G",
                    dataIndex: "3g_cnt",
                    key: "3g_cnt",
                    // sorter: makeTableSorterFn("3g_cnt"),
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "LTE",
                    dataIndex: "lte_cnt",
                    key: "lte_cnt",
                    // sorter: makeTableSorterFn("lte_cnt"),
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "5G",
                    dataIndex: "5g_cnt",
                    key: "5g_cnt",
                    // sorter: makeTableSorterFn("5g_cnt"),
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                ]}
              />
            ) : (
              <WidgetStatisticsTable
                fetchUrl={getApiUrl({ type: "type3" })}
                getTitle={(layer) =>
                  `각 구역에 대한 무선국 밀도(국수/인구 천 명) 요약정보`
                }
                type={"type3"}
                isSummaryInfo={true}
                columns={[
                  {
                    title: "순번",
                    dataIndex: "index",
                    key: "index",
                    width: 75,
                    fixed: "left",
                    // sorter: makeTableSorterFn("index"),
                  },
                  // { title: "지역", dataIndex: "gubun_nm", key: "gubun_nm", sorter: makeTableSorterFn("gubun_nm") },
                  {
                    title: "합계",
                    dataIndex: "tot_cnt",
                    key: "tot_cnt",
                    // sorter: makeTableSorterFn("tot_cnt"),
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "기지국",
                    dataIndex: "32_cnt",
                    // sorter: makeTableSorterFn("32_cnt"),
                    key: "32_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "간이무선국",
                    dataIndex: "94_cnt",
                    // sorter: makeTableSorterFn("94_cnt"),
                    key: "94_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "육상이동국",
                    dataIndex: "44_cnt",
                    // sorter: makeTableSorterFn("44_cnt"),
                    key: "44_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "이동중계국",
                    dataIndex: "85_cnt",
                    // sorter: makeTableSorterFn("85_cnt"),
                    key: "85_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "이동국",
                    dataIndex: "49_cnt",
                    // sorter: makeTableSorterFn("49_cnt"),
                    key: "49_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "아마추어국",
                    dataIndex: "92_cnt",
                    // sorter: makeTableSorterFn("92_cnt"),
                    key: "92_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "의무선박국",
                    dataIndex: "42_cnt",
                    // sorter: makeTableSorterFn("42_cnt"),
                    key: "42_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "선박국",
                    dataIndex: "41_cnt",
                    // sorter: makeTableSorterFn("41_cnt"),
                    key: "41_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "고정국",
                    dataIndex: "21_cnt",
                    // sorter: makeTableSorterFn("21_cnt"),
                    key: "21_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "전파응용설비",
                    dataIndex: "cmfl_cnt",
                    // sorter: makeTableSorterFn("cmfl_cnt"),
                    key: "cmfl_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "기타",
                    dataIndex: "other_cnt",
                    // sorter: makeTableSorterFn("other_cnt"),
                    key: "other_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                ]}
              />
            )}
            {!isClsSearch ? (
              <WidgetStatisticsTable
                fetchUrl={getApiUrl({ type: "type1" })}
                getTitle={(layer) =>
                  `각 구역에 대한 무선국 밀도(국수/인구 천 명) 상세정보`
                }
                type={"type1"}
                columns={[
                  {
                    title: "순번",
                    dataIndex: "index",
                    key: "index",
                    width: 75,
                    fixed: "left",
                    // sorter: makeTableSorterFn("index"),
                  },
                  // { title: "지역", dataIndex: "gubun_nm", key: "gubun_nm", sorter: makeTableSorterFn("gubun_nm") },
                  {
                    title: "인구유형",
                    dataIndex: "type_name",
                    key: "type_name",
                    // sorter: makeTableSorterFn("type_name"),
                  },
                  {
                    title: "합계",
                    dataIndex: "tot_cnt",
                    key: "tot_cnt",
                    // sorter: makeTableSorterFn("tot_cnt"),
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "2G",
                    dataIndex: "2g_cnt",
                    key: "2g_cnt",
                    // sorter: makeTableSorterFn("2g_cnt"),
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "3G",
                    dataIndex: "3g_cnt",
                    key: "3g_cnt",
                    // sorter: makeTableSorterFn("3g_cnt"),
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "LTE",
                    dataIndex: "lte_cnt",
                    key: "lte_cnt",
                    // sorter: makeTableSorterFn("lte_cnt"),
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "5G",
                    dataIndex: "5g_cnt",
                    key: "5g_cnt",
                    // sorter: makeTableSorterFn("5g_cnt"),
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                ]}
              />
            ) : (
              <WidgetStatisticsTable
                fetchUrl={getApiUrl({ type: "type3" })}
                getTitle={(layer) =>
                  `각 구역에 대한 무선국 밀도(국수/인구 천 명) 상세정보`
                }
                type={"type3"}
                columns={[
                  {
                    title: "순번",
                    dataIndex: "index",
                    key: "index",
                    width: 75,
                    fixed: "left",
                    // sorter: makeTableSorterFn("index"),
                  },
                  // { title: "지역", dataIndex: "gubun_nm", key: "gubun_nm", sorter: makeTableSorterFn("gubun_nm") },
                  {
                    title: "인구유형",
                    dataIndex: "type_name",
                    key: "type_name",
                    // sorter: makeTableSorterFn("type_name"),
                  },
                  {
                    title: "합계",
                    dataIndex: "tot_cnt",
                    key: "tot_cnt",
                    // sorter: makeTableSorterFn("tot_cnt"),
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "기지국",
                    dataIndex: "32_cnt",
                    // sorter: makeTableSorterFn("32_cnt"),
                    key: "32_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "간이무선국",
                    dataIndex: "94_cnt",
                    // sorter: makeTableSorterFn("94_cnt"),
                    key: "94_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "육상이동국",
                    dataIndex: "44_cnt",
                    // sorter: makeTableSorterFn("44_cnt"),
                    key: "44_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "이동중계국",
                    dataIndex: "85_cnt",
                    // sorter: makeTableSorterFn("85_cnt"),
                    key: "85_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "이동국",
                    dataIndex: "49_cnt",
                    // sorter: makeTableSorterFn("49_cnt"),
                    key: "49_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "아마추어국",
                    dataIndex: "92_cnt",
                    // sorter: makeTableSorterFn("92_cnt"),
                    key: "92_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "의무선박국",
                    dataIndex: "42_cnt",
                    // sorter: makeTableSorterFn("42_cnt"),
                    key: "42_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "선박국",
                    dataIndex: "41_cnt",
                    // sorter: makeTableSorterFn("41_cnt"),
                    key: "41_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "고정국",
                    dataIndex: "21_cnt",
                    // sorter: makeTableSorterFn("21_cnt"),
                    key: "21_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "전파응용설비",
                    dataIndex: "cmfl_cnt",
                    // sorter: makeTableSorterFn("cmfl_cnt"),
                    key: "cmfl_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                  {
                    title: "기타",
                    dataIndex: "other_cnt",
                    // sorter: makeTableSorterFn("other_cnt"),
                    key: "other_cnt",
                    render: (value) =>
                      AlignRightText({ text: value, numberComma: true }),
                  },
                ]}
              />
            )}
          </WidgetRisingTabs>
          <RMateChartFusionPopulation
            disabled={
              (!isClsSearch &&
                widgetState.service_code_stats_list.length === 0) ||
              (isClsSearch && widgetState.cls_code_stats_list.length === 0)
            }
          />
          {fillColorLegend.length > 0 && (
            <WidgetLegend
              fillColorLegend={fillColorLegend}
              titleColorLegend={"무선국 수"}
              unitColorLegend={"개"}
            />
          )}
        </MapBase>
        <WidgetToolbar />
      </MapPropsProvider>
    </>
  );
}

export default MapFusionPopulation;
